import { useQuery } from "@tanstack/react-query";
import { fetchCartingOptions } from "../api/fetchCartingOptions";

export const useCartingOptions = () => {
  const { data, error, isLoading } = useQuery({
    queryKey: ["cartingOptions"],
    queryFn: fetchCartingOptions,
  });

  return {
    cartingTypes: data?.result?.cartingTypes || [],
    error,
    isLoading,
  };
};
